<template>
  <div class="row">

    <div class="col-12" v-if="this.$route.query.id != null">
      <please-wait-modal/>
      <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Edit User - {{ data_user.name }}</h1>
      </div>
      <ul class="nav nav-tabs" id="user_tab" role="tablist">
        <li class="nav-item" v-for="(data,index) in arr" :key="index">
          <a :href="'#'+data.replace(/ /g,'_')"
            class="nav-link"
            :class="{
              'active': (clicked_header_tab == '' && index == 0) || (clicked_header_tab != '' && clicked_header_tab == data),
            }"
            :id="data+'-tab'"
            data-toggle="tab"
            role="tab"
            :aria-controls="data"
            :aria-selected="index == 0 ? 'true' : 'false'"
            @click="header_tab_clicked(index)">{{ data }}</a>
        </li>
      </ul>
      <div class="tab-content" id="userTabContent">
        <div class="tab-pane fade" :class="{'show active': (clicked_header_tab == '' && index == 0) || (clicked_header_tab != '' && clicked_header_tab == data)}" :id="data.replace(/ /g,'_')" role="tabpanel" :aria-labelledby="data+'-tab'" v-for="(data,index) in arr" :key="index">
          <div class="mt-3">
            <div v-if="index == 0">
              <div v-show="is_loading" class="row">
                <div class="col-12 col-lg-4">
                  <skeleton-box
                    height="200px"
                    width="100%"/>
                  <skeleton-box
                    class="mt-3"
                    height="200px"
                    width="100%"/>
                </div>
                <div class="col-12 col-lg-8">
                  <skeleton-box
                    height="700px"
                    width="100%"/>
                  <skeleton-box
                    class="mt-3"
                    height="500px"
                    width="100%"/>
                </div>
              </div>
              <menu-profile :data_user1="data_user" :is_loading="is_loading" :is_edited="is_edited" 
                @on-get-data="get_data"
                @on-save="save"/>
            </div>

            <table-skeleton v-else v-show="is_loading"/>
            <div v-show="!is_loading">
              <menu-recruit :data_user="data_user" v-if="data == 'rekrut'"/>
              <menu-contract :data_user="data_user" v-else-if="data == 'kontrak pekerjaan'"/>
              <menu-rating :data_user="data_user" v-else-if="data == 'rating dan review'"/>
              <menu-point :data_user="data_user" v-else-if="data == 'point'"/>
              <menu-referral :data_user="data_user" v-else-if="data == 'referral'"/>
              <menu-document :data_user="data_user" v-else-if="data == 'document'"/>
              <menu-health-history :data_user="data_user" v-else-if="data == 'riwayat kesehatan'"/>
              <menu-job-history :data_user="data_user" v-else-if="data == 'riwayat pekerjaan'"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-else>
      <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Add User</h1>
      </div>
      <profile :data="data_user" @on-save="save" :is_edited="is_edited"/>

    </div>

  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import custom_table from '@/layout/table'
import profile from '@/pages/user/user_component/profile'
import table_skeleton from '@/layout/table_skeleton'
import SkeletonBox from '@/layout/skeleton'

import menu_document from '@/pages/user/user_menu/document'
import menu_point from '@/pages/user/user_menu/point'
import menu_recruit from '@/pages/user/user_menu/recruit'
import menu_referral from '@/pages/user/user_menu/referral'
import menu_health_history from '@/pages/user/user_menu/health_history'
import menu_job_history from '@/pages/user/user_menu/job_history'
import menu_contract from '@/pages/user/user_menu/contract'
import menu_rating from '@/pages/user/user_menu/rating'
import menu_profile from '@/pages/user/user_menu/profile'

export default {
  components:{
    'custom-table': custom_table,
    profile,
    'please-wait-modal': please_wait_modal,
    'table-skeleton': table_skeleton,
    'skeleton-box': SkeletonBox,
    'menu-document': menu_document,
    'menu-point': menu_point,
    'menu-recruit': menu_recruit,
    'menu-referral': menu_referral,
    'menu-health-history': menu_health_history,
    'menu-job-history': menu_job_history,
    'menu-contract': menu_contract,
    'menu-rating': menu_rating,
    'menu-profile': menu_profile,
  },
  data(){
    return{
      is_edited: false,
      arr:[
        'profil',
        'rekrut',
        'kontrak pekerjaan',
        'rating dan review',
        'point',
        'referral',
        'document',
        'riwayat kesehatan',
        'riwayat pekerjaan',
      ],
      data_user:{},
      is_loading: true,
      helper_category_data: {},
      clicked_header_tab: '',
    }
  },
  async mounted(){
    if(sessionStorage['id_user_detail_tab'] == this.$route.query.id)
      this.clicked_header_tab = sessionStorage['header_user_detail_tab'] != null ? sessionStorage['header_user_detail_tab'] : ''

    await this.get_data()
    this.is_loading = false
  },
  methods:{
    header_tab_clicked(index){
      sessionStorage['header_user_detail_tab'] = this.arr[index]
      sessionStorage['id_user_detail_tab'] = this.$route.query.id
      this.clicked_header_tab = this.arr[index]
    },
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    async get_data(){
      var response = await axios.get(base_url+'/user?id='+this.$route.query.id)

      var response_data = response.data

      if(response_data.status == "success"){
        this.data_user = response_data.data

        if(this.data_user.type.name == 'Helper')
          this.arr = [
            'profil',
            'rekrut',
            'kontrak pekerjaan formal',
            'rating dan review',
            'referral',
            'document',
            'riwayat kesehatan',
            'riwayat pekerjaan',
          ]
        else if(this.data_user.type.name == 'Majikan')
          this.arr = [
            'profil',
            'rekrut',
            'kontrak pekerjaan formal',
            'rating dan review',
            'referral',
          ]
        else if(this.data_user.type.name == 'Operator')
          this.arr = [
            'profil',
          ]
      }
      else
        this.$toasted.show(response_data.message)
    },
    async get_helper_category_data(id){
      var response = await axios.get(base_url+'/helper-sub-category?id='+id)

      var response_data = response.data

      if(response_data.status == "success"){
        this.helper_category_data = response_data.data
      }
      else
        this.$toasted.show(response_data.message)
    },
    async save(data_user){
      try{
        await this.get_helper_category_data(data_user.helper_sub_category)

        var arr_header = []
        if(this.data_user.type.name == "Helper")
          arr_header = ['name','gender','city','birth_date','email','address','phone_number','weight','height','marital_status','blood_type','religion','education','weight','height','helper_sub_category','requested_price','salary_type','could_live_in','is_afraid_dog','have_work_abroad','is_understood_english','arr_picture','selected_skill','selected_work_at','id_card_number','id_card']
        else if(this.data_user.type.name == "Majikan")
          arr_header = ['name','gender','birth_date','email','address','phone_number','arr_picture','id_card']
        else
          arr_header = ['name','gender','email','address','phone_number']
        var total = arr_header.length
        var counter = 0


        for(let x in arr_header){
          if((!Array.isArray(data_user[arr_header[x]]) && (data_user[arr_header[x]] == '' || data_user[arr_header[x]] == null) && typeof data_user[arr_header[x]] != 'number') || (Array.isArray(data_user[arr_header[x]]) && data_user[arr_header[x]].length == 0 && this.helper_category_data.helper_category.name != 'Kasual')){
            this.$toasted.show(arr_header[x].replace(/arr_/g,'').replace(/selected_/g,'').replace(/_/g,' ')+" is empty")
            break
          }
          counter++
        }


        if(counter == total){
          console.log(data_user)
          $('#please_wait_modal').modal('show')
          var data = JSON.parse(JSON.stringify(data_user))
          if(data.is_change_picture != null && data.is_change_picture){
            for(let x in data.arr_picture)
              data.arr_picture[x].picture = await image2base64(data.arr_picture[x].picture)
          }
          if(data.is_change_id_card != null && data.is_change_id_card)
            data.id_card = await image2base64(data.id_card)
          data.gender = data_user.gender
          data.requested_price = parseFloat(data_user.requested_price.replace(/\./g,'').replace(/,/g,''))
          data.marital_status = {
            id: data_user.marital_status
          }
          data.blood_type = {
            id: data_user.blood_type
          }
          data.religion = {
            id: data_user.religion
          }
          data.tribes = {
            id: data_user.tribes
          }
          data.education = {
            id: data_user.education
          }
          data.city = {
            id: data_user.city
          }
          data.helper_sub_category = {
            id: data_user.helper_sub_category
          }
          data.birth_place = {
            id: data_user.birth_place
          }

          var response = await axios.put(base_url+'/user',data)

          setTimeout(() => {
            $('#please_wait_modal').modal('hide')
          },500)

          var response_data = response.data
          console.log(response_data)

          if(response_data.status == "success"){
            this.is_edited = true
            this.get_data()

            var context = this
            setTimeout(() => {
              context.is_edited = false
            },100)
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },

  }
}
</script>
